export default {
    name: "Contacts",

    data: {
        errors: [],
        form: {
            firstName: "",
            lastName: "",
            company: "",
            telephone: "",
            email: "",
            address: "",
            city: "",
            province: "",
            request: "",
            privacy: false,
            marketing: false
        }
    },

    methods: {
        toggleCheckbox(param) {
            this.form[param] = !this.form[param];
        },

        validate() {
            this.errors = [];
            const emailRegex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

            if (!this.form.firstName) {
                this.errors.push("firstName");
            }

            if (!this.form.lastName) {
                this.errors.push("lastName");
            }

            if (!this.form.telephone) {
                this.errors.push("telephone");
            }

            if (!this.form.email.match(emailRegex)) {
                this.errors.push("email");
            }

            if (!this.form.address) {
                this.errors.push("address");
            }

            if (!this.form.city) {
                this.errors.push("city");
            }

            if (!this.form.province) {
                this.errors.push("province");
            }

            if (!this.form.request) {
                this.errors.push("request");
            }

            if (!this.form.privacy) {
                this.errors.push("privacy");
            }

            return !this.errors.length;
        },

        submit() {
            if (this.validate()) {
                this.$refs.form.submit();
            }
        }
    }
};